<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="firstEPI">Let him who seeks continue seeking</p>
<h1 class="EPIindent">until he finds.</h1>
<h1 class="EPI">When he finds, he will become troubled.</h1>
<h1 class="EPIindent">When he becomes troubled,</h1>
<h1 class="EPIindent">he will be astonished,</h1>
<h1 class="EPIindent">and he will rule over the All.</h1>
<h1 class="EPIS">—<span class="ital _idGenCharOverride-1">Gospel of Thomas</span></h1>
<h1 class="EPI">The best of prophets of the Future is the Past.</h1>
<h1 class="EPIS">—Byron</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// midas-2.vue?9735d396